export default __webpack_public_path__ + "static/media/gallery.57b5ffa9.png";